/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import ShowHidePassword from '../../../ShowHidePassword';
import t from '../../../../i18n/locale-keys';

class SecurityQuestionsTest extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                answers: {}
            },
            questions: {}
        };

        this.props.doTestLogon(null)
            .then(({questions}) => {
                const answers = {};
                Object.keys(questions).forEach((questionKey) => {
                    answers[questionKey] = '';
                });
                this.setState({
                    form: {answers},
                    questions
                });
            });
    }

    handleChange = (questionKey, event) => {
        const answers = this.state.form.answers;

        this.setState({
            form: {
                answers: {...answers, [questionKey]: event.target.value}
            }
        });
    };

    render() {
        const {form: {answers}, questions} = this.state;

        const questionElements = Object.keys(questions).map((questionKey, questionIndex) => {
            const question = questions[questionKey];
            const answer = answers[questionKey];
            return (
                <ShowHidePassword
                    autoFocus={(questionIndex === 0)}
                    name={`answer_id_${questionKey}`}
                    onChange={(event) => this.handleChange(questionKey, event)}
                    key={questionKey}
                    label={question}
                    placeholder={t.secQuestAnswer()}
                    value={answer}
                />
            );
        });

        return (
            <React.Fragment>
                {questionElements}
            </React.Fragment>
        );
    }
}

export default SecurityQuestionsTest;
